import { useEffect, useState } from "react";
import { api } from "@/api";
import { LayoutAutenticado } from "@/componentes/LayoutAutenticado";
import { useAutenticacao } from "@/contextos/AutenticacaoContexto";
import { toast } from "sonner";
import { ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function GerenciarRegulamento() {
  const { usuario } = useAutenticacao();
  const [regulamento, setRegulamento] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/publico/regulamento");
        setRegulamento(data?.conteudo || "");
      } catch (e) {
        toast.error("Erro ao carregar regulamento");
      } finally {
        setCarregando(false);
      }
    })();
  }, []);

  const salvar = async (e) => {
    e.preventDefault();
    if (usuario?.perfil !== "SUPER_ADMIN") {
      toast.error("Apenas Super Admin pode editar o regulamento");
      return;
    }

    setEnviando(true);
    try {
      await api.patch("/admin/regulamento", {
        conteudo: regulamento,
        versao: "1.0",
      });
      toast.success("Regulamento atualizado com sucesso!");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erro ao salvar regulamento");
    } finally {
      setEnviando(false);
    }
  };

  if (carregando) {
    return (
      <LayoutAutenticado>
        <div className="text-white/40">Carregando...</div>
      </LayoutAutenticado>
    );
  }

  return (
    <LayoutAutenticado>
      <div data-testid="pagina-gerenciar-regulamento">
        <div className="mb-8 flex items-center gap-4">
          <Link to="/admin" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors">
            <ChevronLeft className="w-4 h-4" />
            Voltar
          </Link>
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.3em] text-amarelobrasil">Sistema</div>
            <h1 className="font-heading text-4xl font-bold uppercase mt-1">Editar Regulamento</h1>
          </div>
        </div>

        <form onSubmit={salvar} className="max-w-4xl">
          <div className="surface-card rounded-2xl p-6 md:p-8 mb-6">
            <label className="block mb-4">
              <span className="text-sm font-bold uppercase tracking-widest text-white mb-3 block">Conteúdo do Regulamento</span>
              <textarea
                value={regulamento}
                onChange={(e) => setRegulamento(e.target.value)}
                className="w-full h-96 bg-white/5 border border-white/10 rounded-lg p-4 text-white placeholder-white/40 focus:outline-none focus:border-amarelobrasil focus:ring-1 focus:ring-amarelobrasil"
                placeholder="Digite o conteúdo do regulamento..."
                disabled={enviando}
              />
            </label>
            <p className="text-[10px] text-white/40 mt-2">
              Este conteúdo será exibido na página pública e no aceite obrigatório do primeiro login.
            </p>
          </div>

          <div className="flex gap-3">
            <button
              type="submit"
              disabled={enviando}
              className="px-8 py-3 rounded-md font-heading uppercase tracking-widest text-sm bg-verdebrasil hover:bg-verdebrasil-dark transition-all hover:glow-green disabled:opacity-50"
              data-testid="btn-salvar-regulamento"
            >
              {enviando ? "Salvando..." : "Salvar Regulamento"}
            </button>
            <Link
              to="/admin"
              className="px-8 py-3 rounded-md font-heading uppercase tracking-widest text-sm text-white/60 hover:text-white border border-white/10 transition-all"
            >
              Cancelar
            </Link>
          </div>
        </form>
      </div>
    </LayoutAutenticado>
  );
}
